<div class="channel-not-found-container" *ngIf="showChannelErrorPage">
  <img src="assets/generalImage/not_found.svg" alt="mascot">
  <span class="desc">{{'desc.channel.not.found.pls.try.again.later' | translate}}</span>
</div>
